import { useCopilot } from 'context/copilot';

import { useApplyCustomFunctionCodeTool } from './tools/useApplyCustomFunctionCodeTool';
import { useCreatePipelineTool } from './tools/useCreatePipelineTool';
import { useListAvailableMetricsTool } from './tools/useListAvailableMetricsTool';
import { useListCamerasTool } from './tools/useListCamerasTool';
import { useListDeploymentsTool } from './tools/useListDeploymentsTool';
import { useListEventsTool } from './tools/useListEventsTool';
import { useListGatewaysTool } from './tools/useListGatewaysTool';
import { useListPipelinesTool } from './tools/useListPipelinesTool';
import { useListStreamsTool } from './tools/useListStreamsTool';
import { useListWatchlistsTool } from './tools/useListWatchlistsTool';
import { useListWatchlistItemsTool } from './tools/useListWatchlistItemsTool';
import { useNavigateConsoleTool } from './tools/useNavigateConsoleTool';
import { useQueryAnalyticsTool } from './tools/useQueryAnalyticsTool';
import { useQueryDataTableTool } from './tools/useQueryDataTableTool';
import { useSearchFilesTool } from './tools/useSearchFilesTool';
import { useSearchPipelineTemplatesTool } from './tools/useSearchPipelineTemplatesTool';
import { useShowCamerasTool } from './tools/useShowCamerasTool';
import { useShowStreamsTool } from './tools/useShowStreamsTool';
import { useShowWatchlistStatusTool } from './tools/useShowWatchlistStatusTool';
import { useUpdatePipelineTool } from './tools/useUpdatePipelineTool';

function MCPFrontendToolsInner() {
  // Pipeline tools
  useCreatePipelineTool();
  useUpdatePipelineTool();
  useSearchPipelineTemplatesTool();
  useApplyCustomFunctionCodeTool();

  // Data query tools (no UI, return JSON to model)
  useListAvailableMetricsTool();
  useListGatewaysTool();
  useListCamerasTool();
  useListStreamsTool();
  useListPipelinesTool();
  useListDeploymentsTool();
  useListEventsTool();
  useListWatchlistsTool();
  useListWatchlistItemsTool();

  // Frontend tools (render UI in chat)
  useQueryAnalyticsTool();
  useQueryDataTableTool();
  useSearchFilesTool();
  useShowCamerasTool();
  useShowStreamsTool();
  useShowWatchlistStatusTool();

  // Navigation tools
  useNavigateConsoleTool();

  return null;
}

export function MCPFrontendTools() {
  const { isAvailable } = useCopilot();

  if (!isAvailable) {
    return null;
  }

  return <MCPFrontendToolsInner />;
}
